import taskManagerApi from '@/features/shared/services/taskManagerApi';
/**
 * Fetch all client types.
 */
export async function fetchClientType() {
    try {
        const response = await taskManagerApi.get(`/client_type`);
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération des types de client");
        }
    }
}
/**
 * Delete a client type by its ID.
 */
export async function deleteClientType(id) {
    try {
        await taskManagerApi.delete(`/client_type/${id}`);
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la suppression du type de client");
        }
    }
}
/**
 * Create a new client type.
 */
export async function addClientType(client_type) {
    try {
        const response = await taskManagerApi.post(`/client_type`, client_type);
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de l'ajout du type de client");
        }
    }
}
/**
 * Update an existing client type.
 */
export async function updateClientType(client_type) {
    try {
        const response = await taskManagerApi.put(`/client_type/${client_type.id}`, client_type);
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la mise à jour du type de client");
        }
    }
}
